import React from 'react';

import { styled } from 'baseui';

import { Feedback } from '../../../../Components/Feedback';

const FeedbackWrapper = styled('div', {
    position: 'absolute',
    right: 'var(--epods--space-inset-m)',
    bottom: '60px',
    left: 'var(--epods--space-inset-m)',
});

function KSMFeedback({ title, text, displayTitleOnTooltip, onClose }: { title?: string, text: string, displayTitleOnTooltip: boolean | undefined, onClose: () => void }) {
    return (
        <FeedbackWrapper>
            <Feedback
                displayTitleOnTooltip={displayTitleOnTooltip}
                title={title}
                text={text}
                kind="positive"
                className="w-100"
                noEllipsis
                displayBlock
                autoHideDuration={4000}
                onClose={onClose}
            />
        </FeedbackWrapper>
    );
}

export default KSMFeedback;